// Who may see the billing tab of the business KPIs. The backend enforces the
// same list (BILLING_DASHBOARD_USERS in fpf/billing/dashboard.py): keep both in
// sync.
export default ['daniel.garrido@foodforjoe.es', 'jordi.antoja@foodforjoe.com'];
